module.exports = __webpack_public_path__ + "assets/img/2c2c4c244b44e86718d088f4167150d9.png";